import React, { useState } from "react";
import { Modal, Table, Space, Button, Spin, Row, Col } from 'antd';
import StringHelper from '../helpers/StringHelper';
import moment from 'moment-jalaali';
import strings from "../../utils/strings";
import { ZoomInOutlined } from "@ant-design/icons";
import CrmCallReasonModal from "../user-business-report/crmReport/crmCallHistory/crmCallReasonModal";
import CrmCallHistoryModal from "../user-business-report/crmReport/crmCallHistory/CrmCallHistoryModal";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";


export default function RenewalCalls({ applicantUserId, requestId }) {
    const general = useGeneralStore();
    const reports = useReportsStore()
    const visible = general.view.renewalCallModal;
    const data = reports.crmCalls.data;
    const loading = reports.crmCalls.loading;

    const [id, setID] = useState();
    const columns = [
        {
            title: 'مشاهده',
            dataIndex: "operation",
            width: 80,
            key: "operation",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">

                        <Button type='link' htmltype="submit"
                            onClick={() => {
                                setID(record.Id)
                                reports.getCrmCallHistoryReason(record.Id);
                                general.ToggleCrmCallReasonModal(true);
                            }}>
                            <ZoomInOutlined />
                        </Button>

                    </Space>
                )
        },
        {
            title: 'کد تماس',
            dataIndex: 'Id',
            width: 60,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },


        },
        {
            title: 'شناسه کاربر',
            dataIndex: 'UserId',
            key: 'UserId',
            width: 130,
        },
        {
            title: 'شماره همراه',
            dataIndex: "PhoneNumber",
            key: "PhoneNumber",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PhoneNumber ? (first = a.PhoneNumber) : (first = "");
                b.PhoneNumber ? (second = b.PhoneNumber) : (second = "");
                return first.localeCompare(second);
            },


        },
        {
            title: 'دلیل تماس',
            dataIndex: 'ReasonTitle',
            width: 160,
            key: 'ReasonTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'وضعیت تماس',
            dataIndex: 'CallStatusTitle',
            width: 110,
            key: 'CallStatusTitle',
        },
        {
            title: 'نوع تماس',
            dataIndex: 'CallTypeTitle',
            width: 110,
            key: 'CallTypeTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 130,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "کد رهگیری",
            dataIndex: "RequestNumber",
            key: "RequestNumber",
            width: 150,
            sorter: (a, b) => a.RequestNumber.localeCompare(b.RequestNumber),
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            width: 300,
            key: "Description",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },

    ];
    return (
        <Modal
            width={'85%'}
            title={` کل تماس های مربوط به درخواست  ${requestId}`}
            className="custom-table modal-scroll cmModal"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleRenewalCallModal()}>
            <Spin spinning={loading}>
                <Row
                    gutter={[16, 16]}>
                    <Col span={24}>
                        <button type="primary" style={{ marginBottom: "-2rem", marginTop: "- 1rem", cursor: "pointer" }} className="btn btn-primary waves-effect waves-light float-left"
                            onClick={() => general.ToggleCrmCallHistoryModal(true)}>
                            <i className="fas fa-plus font-size-14 align-middle mr-2 "></i> افزودن تماس جدید
                        </button>
                    </Col>
                    <Col span={24}>
                        {data && data.length > 0 ? <>
                            <Table
                                style={{ overflowX: 'scroll' }}
                                size="small"
                                className="custom-table crm-request-report"
                                bordered
                                loading={loading}
                                rowKey="ID"
                                scroll={true}
                                dataSource={data}
                                columns={columns}
                            />

                        </>
                            :
                            <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>تماس یافت نشد</div>}
                        <CrmCallReasonModal callHistoryId={id} />
                        <CrmCallHistoryModal renewalCall={true} usrUserID={applicantUserId} requestId={requestId} />
                    </Col>
                </Row>
            </Spin>
        </Modal >
    )
}
